import { faSpinner } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button as BootstrapButton } from 'react-bootstrap';

interface IProps {
  label?: string;
  variant?: string;
  className?: string;
  isMultiLine?: boolean;
  size?: 'sm' | 'lg';
  onClick?: () => void;
  children?: React.ReactNode;
  disabled?: boolean;
  isProcessing?: boolean;
}

export const Button = (props: IProps) => {
  let className = `text-uppercase font-weight-bold ${props.className ?? ''}`;
  if (props.isMultiLine) {
    className = `${className} ${props.isMultiLine ? 'multiline' : ''}`.trim();
  }
  return (
    <BootstrapButton
      variant={props.variant}
      className={className}
      size={props.size ?? 'lg'}
      onClick={props.onClick}
      disabled={props.disabled || props.isProcessing}
    >
      {props.isProcessing && (
        <>
          <FontAwesomeIcon icon={faSpinner} className="fa-spin" />{' '}
        </>
      )}
      {props.children ?? props.label}
    </BootstrapButton>
  );
};
